import { FORM_FIELDS } from '../../../modals/common/PasswordSettingsSection/fieldset'

/**
 * Maps PasswordSettingsSection Formik values to the Probe-shaped values
 * expected by GWS getTaskParameters callbacks.
 */
export const mapGwsPasswordFormValues = (values = {}) => {
  const sendPasswordOnCompletion = values[FORM_FIELDS.SEND_PASSWORD_ON_COMPLETION]
  const isSendingPasswordToMe = values[FORM_FIELDS.IS_SENDING_PASSWORD_TO_ME]

  return {
    newPassword: values[FORM_FIELDS.NEW_PASSWORD],
    sendPasswordTo: Boolean(sendPasswordOnCompletion),
    email: sendPasswordOnCompletion && isSendingPasswordToMe ? values[FORM_FIELDS.CURRENT_USER_EMAIL] : undefined,
    employee:
      sendPasswordOnCompletion && !isSendingPasswordToMe
        ? { value: { email: values[FORM_FIELDS.SEND_PASSWORD_TO_EMPLOYEE_EMAIL] } }
        : undefined,
  }
}

export const getGwsDomainValue = (domain) => {
  if (domain && typeof domain === 'object') {
    return domain.value
  }

  return domain
}
